import { get, post } from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { showToast } from "utils"
import {
  assignPermissionFailed,
  assignPermissionSuccess,
  getPermissionsFailed,
  getPermissionsSuccess,
} from "./actions"
import * as url from "helpers/url_helper"
import { ASSIGN_PERMISSION, GET_PERMISSIONS } from "./actionTypes"

function* getPermissions({ payload: params }) {
  try {
    const response = yield get(url.PERMISSION_URL)
    yield put(getPermissionsSuccess(response))
  } catch (error) {
    yield put(getPermissionsFailed(error))
    showToast("error", error, "Error")
  }
}

function* assignPermission({ payload: params }) {
  try {
    const response = yield post(url.ADMIN_ASSIGN_URL, params)
    yield put(assignPermissionSuccess(response))
    showToast("success", "Settings saved!", "Success")
  } catch (error) {
    yield put(assignPermissionFailed(error))
    showToast("error", error, "Error")
  }
}

function* permissionsSaga() {
  yield takeEvery(GET_PERMISSIONS, getPermissions)
  yield takeEvery(ASSIGN_PERMISSION, assignPermission)
}

export default permissionsSaga
